import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=2d60b060&scoped=true"
import script from "./orderDialog.vue?vue&type=script&lang=js"
export * from "./orderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60b060",
  null
  
)

component.options.__file = "orderDialog.vue"
export default component.exports